define('views/modules/profile/edit/custom-message-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/profile/edit/custom-message-edit-form',
    // templates
    'text!templates/modules/profile/edit/custom-message-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // views
    VForm,
    VMenuSaveAction,
    VCustomMessageEditForm,
    // templates
    TCustomMessageEditContent
) {

    var VCustomMessageEditContent = VForm.extend({
        fields: ['title', 'message', 'defaultWelcomeMessage'],
        template: TCustomMessageEditContent,

        regions: {
            root: "#custom-message-edit-content",
            menu: ".menu-actions",
            form: ".custom-message-edit-form",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var model = this.model,
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: "Save",
                        //radio: true,
                        tooltip: { container: this.regions.root, }
                    }),
                    form: new VCustomMessageEditForm({
                        model: this.model,
                        group: opt.group
                    })
                };

            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.setPristine();

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            this.submit();
        },

        onSuccess: function() {
            this.trigger('form:success', this.model.clone());
        },
    });

    return VCustomMessageEditContent;
});

